import { omitBy, isNil, compact, isUndefined, find } from "lodash";
import statesCities from "Components/profile/profile-details/addresses/country_MY.json";
import { CustomerLocationFormType } from "Types/customer_location.types";

const response = (data: CustomerLocationFormType) => {
  const workingHourFormatter = () => {
    let formattedWorkingHours = data?.workingHours?.map((current) => {
      if (current?.isChecked)
        return {
          day: current?.day,
          openingTime: current?.openingTime,
          closingTime: current?.closingTime,
        };
    });

    return compact(formattedWorkingHours);
  };

  return {
    location: omitBy(
      {
        primary: data.primary,
        _id: data._id ? data._id : undefined,
        orgID: data.customerID ? data.customerID : undefined,
        orgName: data.customerName,
        address: omitBy(
          {
            street1: data.street1,
            street2: data.street2 ? data.street2 : undefined,
            city: data.city,
            cityCode: find(
              find(statesCities.STATES, (element) => data.state === element.NAME)?.CITIES,
              (element) => element.NAME === data.city
            )?.CODE,
            state: data.state,
            stateCode: find(statesCities.STATES, (element) => data.state === element.NAME)?.CODE,
            postcode: data.postcode,
            country: data.country,
          },
          (value) => isUndefined(value)
        ),
        coordinate: data.coordinate,
        locationName: data.customerLocationName ? data.customerLocationName : undefined,
        workingHours: workingHourFormatter(),
        handlingInstructions: data.handlingInstructions,
        orgType: data.orgType,
        contactPerson: data.contactPerson ? data.contactPerson : undefined,
        contactEmail: data.emailAddress ? data.emailAddress : undefined,
        contactNumber: {
          countryCode: data.contactNo.dialCode,
          number: data.contactNo.number,
          fullNumber: `${data.contactNo.dialCode}${data.contactNo.number}`,
          type: "MOBILE",
        },
      },
      (value) => isUndefined(value)
    ),
  };
};

export default response;
